import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import {
  SInputDropdown,
} from '@simmons/components';

import { AppMutations } from '@/store/modules/app/mutations';
import { LOCAL_STORAGE_SELECTED_PRODUCT_KEY } from '@/config/constants';
import { getRouteNames } from '@/utils';

import useUserAccess from '@/composables/useUserAccess';
import useSelectedProduct from '@/composables/useSelectedProduct';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const route = useRoute();
const store = useStore();

const currentlySelectedProduct = computed(
  (): string => route.path.split('/')[1],
);

const { selectedProduct } = useSelectedProduct();
const { productsUserCanAccess } = useUserAccess(selectedProduct);

const setSelectedProductInState = (_selectedProduct: string): void => (
  store.commit(AppMutations.APP__SET_SELECTED_PRODUCT, _selectedProduct)
);

const setSelectedProductInLocalStorage = (_selectedProduct: string): void => (
  localStorage.setItem(LOCAL_STORAGE_SELECTED_PRODUCT_KEY, _selectedProduct)
);

const pushToRoute = (routeName: string): void => {
  router.push({
    name: routeName,
  });
};

const handleChangeProduct = (productValue: string): void => {
  if (productValue) {
    const routeNames = getRouteNames(router.getRoutes());
    const existingProductRoute = routeNames.find(
      (routeName) => (routeName === productValue),
    );

    setSelectedProductInState(productValue);
    setSelectedProductInLocalStorage(productValue);

    if (existingProductRoute) {
      pushToRoute(existingProductRoute);
    }
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(SInputDropdown), {
    class: "product__dropdown",
    options: _unref(productsUserCanAccess),
    "model-value": _unref(currentlySelectedProduct),
    "dark-bg": true,
    "onUpdate:modelValue": handleChangeProduct
  }, null, 8, ["options", "model-value"]))
}
}

})